<ul class="mr-auto navbar-nav">
  <li
    class="nav-item"
    [ngClass]="toUpperCase ? 'text-uppercase' : null"
    *ngFor="let item of items; let i = index"
  >
    <app-nav-item [item]="item"></app-nav-item>
  </li>
</ul>
